<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.configuracaoRastreabilidade.plantaFabril.titulo")',
        :voltarPara='{ route: "ConfiguracaoPlanta" }'
    )
    .detalhes-gerente-comercial
        h3 {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.dadosCadastrais') }}
        .detalhes-gerente-comercial__card
            Resume(resumeId='detalhes-material', :resume='resumeList')
        .detalhes-gerente-comercial__card
            .detalhes-cadastro-planta
                .detalhes-cadastro-planta__dados-adicionais
                    .detalhes-cadastro-planta__dados-adicionais-titulo
                        h3 {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.dadosAdicionais') }}
                    .detalhes-cadastro-planta__dados-adicionais-content
                        .detalhes-cadastro-planta__dados-adicionais-vazio(v-if='!planta.subprodutos || planta.subprodutos.length === 0')
                            span {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.dadosAdicionaisVazio') }}
                        template(v-else)
                            .detalhes-cadastro-planta__coluna(
                                v-for="(sub, index) in planta.subprodutos"
                                :key="`subproduto-${index}`"
                            )
                                .detalhes-cadastro-planta__linha
                                    span {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.commodity') }}
                                    span {{ planta.materialEntrada?.nome || '--' }}
                                .detalhes-cadastro-planta__linha
                                    span {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.subproduto') }}
                                    span {{ sub.nome || '--' }}
                                .detalhes-cadastro-planta__linha
                                    span {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.percentual') }}
                                    span {{ sub.percentual }}%
                        
        .footer
            .footer__btn.voltar(@click='irParaListagem')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import { buscarPlantaFabrilPorId } from '@/views/contratos-originacao/planta-fabril/services';

export default {
    name: 'DetalhesPlantaFabril',
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Resume: () =>
            import('@/components/contratosOriginacao/formulario/Resume')
    },
    data() {
        return {
            planta: {}
        };
    },
    computed: {
        resumeList() {
            const resume = [
                {
                    key: 'id',
                    label: this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.id'),
                    value: this.planta?.id || '--'
                },
                {
                    key: 'nome',
                    label: this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.nome'),
                    value: this.planta?.nome || '--'
                },
                {
                    key: 'commodity',
                    label: this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.commodity'),
                    value: this.planta?.materialEntrada?.nome || '--'
                }
            ];
            return resume;
        }
    },
    mounted() {
        this.buscarDados();
    },
    methods: {
        async buscarDados() {
            const id = this.$route.params.id;
            if (!id) return;

            try {
                const { data } = await buscarPlantaFabrilPorId(id);
                this.planta = data;
            } catch (error) {
                this.$notify.error(
                    this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.erroBuscar')
                );
            }
        },
        irParaListagem() {
            this.$router.push({ name: 'ConfiguracaoPlanta' });
        }
    }
};
</script>

<style lang="scss" scoped>
.detalhes-gerente-comercial {
    .detalhes-cadastro-planta {
        margin-top: 10px;
        background-color: $white;
        display: flex;
        flex-direction: column;
        gap: 20px;

        &__coluna {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
        }
        
        &__coluna + .detalhes-cadastro-planta__coluna {
            border-top: 1px solid #555555;
        }

        &__linha {
            padding: 0 12px;
            margin: 6px 0;
            display: flex;
            justify-content: center;
            flex-direction: column;
            font-size: 16px;
            & :first-child {
                color: #868686;
                font-size: 14px;
            }
        }

        &__linha + .detalhes-cadastro-planta__linha {
            border-left: 1px solid #555555;
        }
        &__percentual {
            display: flex;
            gap: 3px;
            flex-direction: column;
        }

        &__percentual-input {
            display: flex;
            gap: 16px;

            input {
                width: 70px;
            }
        }

        &__percentual-btn {
            display: flex;
            align-items: center;
            gap: 8px;
            justify-content: center;
            width: fit-content;
            height: 40px;
            border-radius: 4px;
            border: 1px solid #81BE99;
            color: #81BE99;
            outline: 0;
            padding: 0 15px;
        }

        &__divider {
            border: 8px solid #E1E1E1;
            border-radius: 8px;
            height: 1px;
        }

        &__arrow-divider {
            position: relative;

            i {
                color: #E1E1E1;
                top: -58px;
                left: calc(50% - 30px);
                width: 60px;
                background-color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 60px;
                font-size: 42px;
                line-height: 42px;
                position: absolute;
                transform: rotate(270deg);
            }
        }

        &__dados-adicionais {
            border: 2px dashed #7C7C7C;
            border-radius: $default-border-radius;
            position: relative;
            margin-top: 8px;
        }

        &__dados-adicionais-titulo {
            border: 1px solid #7C7C7C;
            padding: 4px 8px;
            color: #7C7C7C;
            position: absolute;
            border-radius: 20px;
            width: 280px;
            background-color: #F2F2F2;
            position: absolute;
            top: -16px;
            left: calc(50% - 140px);

            h3 {
                text-align: center;
                font-weight: bold;
            }
        }

        &__dados-adicionais-content {
            padding: 8px;
            margin: 38px 16px 16px;
            border-top: 1px solid #555555;
            border-bottom: 1px solid #555555;
        }

        &__dados-adicionais-vazio {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;
            padding: 32px 0;
        }
    }

    margin: 20px;

    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }

    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();

        &+& {
            margin-top: 20px;
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end !important;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
